// date & time (2021-12-13T05:00:00Z) - 12/13/2021 5:00am UTC
// date (1987-04-28) - 04/28/1987

// height (82) - 6'10”
// (convert to feet and inches)
// weight (245) - 245 lbs.
// (add “ lbs.” to the end of the value)
// percentiles (0.65) - 65%
// (multiply by 100 and add “%” to the end)

export const arrayKeys = {
  seasons: {
    keys: ['seasonYear', 'seasonTypeCode'],
    separator: '-',
  },
  teams: {
    keys: ['teamName'],
  },
  Coaches: {
    keys: ['coachFullName'],
  },
  Players: {
    keys: ['playerFullName'],
  },
  teamColor: {
    keys: ['type'],
  },
  periods: {
    keys: ['number'],
  },
  officials: {
    keys: ['fullName'],
  },
};

export const noRenderKeys = [
  // v1 Fields (API
  'sr_id',
  'reference',
  'season_id',
  '_comment',
  'last_modified',
  'updated',
  // v2 Fields - GraphQL
  '__typename',
  'id',
  'leagueId',
  'seasonId',
  'conferenceId',
  'divisionId',
  'teamId',
  'homeTeamId',
  'awayTeamId',
  'playerId',
  'gameId',
  'scheduledForUnix',
  'scheduledFor',
  'venueId',
];

export const topLevelKeys = {
  PlayerGameStats: 'Player Game Stats',
  PlayerSeasonStats: 'Player Season Stats',
  TeamGameStats: 'Team Game Stats',
  TeamSeasonStats: 'Team Season Stats',
};

export const resolverNames = {
  PlayerGameStats: 'PlayerGameStats',
  PlayerSeasonStats: 'PlayerSeasonStats',
  TeamGameStats: 'TeamGameStats',
  TeamSeasonStats: 'TeamSeasonStats',
  seasonsTeams: 'seasonsTeams',
};
